import { useEditor, useNode } from "@craftjs/core";
import { useRouter } from "next/router";
import * as React from "react";
import isSSR from "src/utils/is-ssr";

import Footer from "@/components/editor/footer/footer-component";

import LayoutDefaultCard from "../../preference-panel/layout/layout-default-card-component";
import { ResizeViewport } from "../../resize-viewport";
import { Main, StyledPageContainer } from "./page-container-component-styles";

type Props = {
  children?: React.ReactNode;
};

/**
 * `PageContainer` wraps the entire page to allow pages to take up at least 100% of the screen.
 */
export default function PageContainer(props: Props) {
  if (isSSR) {
    return <Server {...props} />;
  }
  return <Client {...props} />;
}

PageContainer.craft = {
  isCanvas: true,
  related: {
    settings: LayoutDefaultCard,
  },
};

function Client(props: Props) {
  const {
    connectors: { connect },
  } = useNode();
  const { pathname } = useRouter();

  const { enabled } = useEditor((state) => ({
    enabled: state.options.enabled,
  }));

  return (
    <StyledPageContainer
      ref={connect}
      data-testid="page-container"
      $editing={enabled}
      inEditPage={pathname.endsWith("/edit")}
    >
      <Main>
        <ResizeViewport>{props.children}</ResizeViewport>
      </Main>
      <Footer />
    </StyledPageContainer>
  );
}

function Server(props: Props) {
  return (
    <StyledPageContainer data-testid="page-container">
      <ResizeViewport>{props.children}</ResizeViewport>
    </StyledPageContainer>
  );
}
